import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthProvider'
import { SignIn } from './auth/SignIn'
import { SetPassword } from './auth/SetPassword'
import { OrgProvider, useOrg } from './org/OrgProvider'
import { Rail } from './components/Rail'
import { TopBar } from './components/TopBar'
import { Loading } from './components/bits'
import { Today } from './screens/Today'
import { People } from './screens/People'
import { Person } from './screens/Person'
import { Planday } from './screens/Planday'
import { FrontDesk } from './screens/FrontDesk'
import { Sickness } from './screens/Sickness'
import { Toil } from './screens/Toil'
import { ReturnToWork } from './screens/ReturnToWork'
import { Audit, RightToWork, Starters } from './screens/Proposed'

function Console() {
  // Reception holds no read access to anything else, so landing them on Today
  // would mean a screen of empty panels. They get the one thing they are here
  // to do. Anybody with a staff role keeps the normal console, including
  // somebody who is both front_desk and hr.
  const { current } = useOrg()
  const frontDeskOnly = current.roles.length > 0 && current.roles.every((r) => r === 'front_desk')
  const home = frontDeskOnly ? <Navigate to="/sickness" replace /> : <Today />

  return (
    <div className="shell">
      <Rail />
      <main>
        <TopBar />
        <Routes>
          <Route path="/" element={home} />
          <Route path="/people" element={<People />} />
          <Route path="/people/:employmentId/*" element={<Person />} />
          <Route path="/right-to-work" element={<RightToWork />} />
          <Route path="/absence" element={<Sickness />} />
          <Route path="/absence/:episodeId" element={<ReturnToWork />} />
          <Route path="/starters" element={<Starters />} />
          <Route path="/sickness" element={<FrontDesk />} />
          <Route path="/toil" element={<Toil />} />
          <Route path="/planday" element={<Planday />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="*" element={home} />
        </Routes>
        <footer className="note">
          <strong>TFH&thinsp;&middot;&thinsp;HR.</strong> This platform is the system of record for
          people and compliance. Planday holds clock-ins, contracted hours and the deactivation
          date, and nothing else. Where a value is mirrored from Planday it says so, and where a
          date was guessed rather than received it is marked, because a guessed date that looks
          certain is worse than no date at all.
        </footer>
      </main>
    </div>
  )
}

function Gate() {
  const { session, ready, mustSetPassword } = useAuth()
  if (!ready) return <Loading what="your session" />
  if (session === null) return <SignIn />
  // An invitation or reset link signs somebody in without a password of their
  // own. Letting them past here would leave an account that nobody can get
  // back into once the link expires.
  if (mustSetPassword) return <SetPassword />
  return (
    <OrgProvider>
      <Console />
    </OrgProvider>
  )
}

export function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  )
}
